<template>
  <div class="home">
    <div class="header"></div>
    <top v-if="isPc"></top>
    <top-wap v-else></top-wap>
    <notice class="wow fadeInDown"></notice>
    <!-- 倒计时 -->
    <djs class="wow fadeInUp"></djs>
    <!-- Community -->
    <community></community>
    <!-- Conference -->
    <conference :dateList="dateList"></conference>
    <!-- Circle -->
    <mycircle :dateList="dateList"></mycircle>
    <!-- banner -->
    <bannerNew v-if="banners.home && banners.home.length"></bannerNew>
    <banner v-else></banner>
    <!-- huoban -->
    <huoban :data="partnerList1"></huoban>
    <!-- camp -->
    <camp></camp>
    <!-- hezuo -->
    <hezuo :data="partnerList2"></hezuo>
    <yunpingtai></yunpingtai>
  </div>
</template>

<script>
import top from './components/top.vue'
import topWap from './components/topWap.vue'
import notice from './components/notice.vue'
import djs from './components/djs.vue'
import community from './components/community.vue'
import conference from './components/conference.vue'
import mycircle from './components/mycircle.vue'
import banner from './components/banner.vue'
import bannerNew from './components/bannerNew.vue'
import huoban from './components/huoban.vue'
import camp from './components/camp.vue'
import hezuo from './components/hezuo.vue'
import yunpingtai from './components/yunpingtai.vue'
import { WOW } from "wowjs";
import protal from "@/api/protal";

export default {
  name: 'index',
  components: {
    top,
    topWap,
    notice,
    djs,
    community,
    conference,
    mycircle,
    banner,
    bannerNew,
    huoban,
    camp,
    hezuo,
    yunpingtai
  },
  data() {
    return {
      partnerList: [],
      partnerList1: [],
      partnerList2: [],
      dateList: []
    }
  },
  created() {
    this.pageView('gw_homepage')
    this.getTime()
    this.getData()
  },
  mounted() {
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
    });
    wow.init();
    // gio('track','homeClick',
    //     {
    //       'floor_var':'首页banner',
    //       'position_var': '1',
    //       'flowName_var': '看见并释放世界价值',
    //       'tabName_var': '无'
    //     }
    // );
			if (this.$route.name === 'en' && !this.En) {
				this.changeLang()
			}
  },
  methods: {
    changeLang() {
      let locale = this.$i18n.locale;
      locale === "ch" ? (this.$i18n.locale = "en") : (this.$i18n.locale = "ch");
      localStorage.setItem("lang", this.$i18n.locale);
    },
    getTime() {
      protal.getJson("home_forum", (data) => {
          this.dateList = data;
      });
    },
    async getData() {
      await protal.getZdType("partners_type").then((res) => {
        if (res && res.data && res.data.length) {
          this.typeList = res.data;
        }
      });
      let partnerObj = {
        partnersType: "",
        pageNum: 1,
        pageSize: 999,
      };
      protal.queryPartnersList(partnerObj).then((res) => {
        if (res && res.data && res.data.length) {
          this.partnerList = res.data.filter(x => x.isSpecial != 0)
          let dataArr = [];
          this.partnerList.map((mapItem) => {
            if (dataArr.length == 0) {
              dataArr.push({
                partnersType: mapItem.partnersType,
                List: [mapItem],
              });
            } else {
              let res = dataArr.some((item) => {
                if (item.partnersType == mapItem.partnersType) {
                  item.List.push(mapItem);
                  return true;
                }
              });
              if (!res) {
                dataArr.push({
                  partnersType: mapItem.partnersType,
                  List: [mapItem],
                });
              }
            }
          });
          this.partnerList = dataArr;
          const partnerList = this.typeList.map((item) => {
            return this.partnerList.map((mapItem) => {
              if (mapItem.partnersType == item.uuid) {
                mapItem.title = item.lableDesc;
                mapItem.titleEn = item.lableDescEn;
                mapItem.lableValue = item.lableValue
              }
              return mapItem
            }).filter(mapItem => mapItem.partnersType == item.uuid)[0]
          });
          this.partnerList1 = partnerList.filter(x => x && x.lableValue != 'media')
          const partnerList2 = partnerList.filter(x => x && x.lableValue == 'media')
          const arr = [
            {
              title: "合作媒体",
              titleEn: "Partnering Media",
              partnersType: "1567e6e6260e4185ae2a0f7fd7a6716f",
              lableValue: "media",
              List: []
            }
          ]
          partnerList2.forEach(x => {
            arr[0].List = [...arr[0].List, ...x.List]
          })
          this.partnerList2 = arr
          // console.log(partnerList, 111)
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  // .header {
  //   position: fixed;
  //   left: 0;
  //   right: 0;
  //   top: 0;
  //   height: 96px;
  //   background: rgba(0, 0, 0, 0.5);
  //   z-index: 10;
  // }
  .home {
    position: relative;
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {

}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue